import { Theme } from "../types/types";

export const darkTheme: Theme = {
  background: "#1a1a2e",
  surface: "#16213e",
  text: "#ffffff",
  textSecondary: "#a0a0b0",
  accent: "#4a90e2",
  border: "#2a2a4a",
  selected: "#2a4a7a",
  hover: "#252545",
};

export const lightTheme: Theme = {
  background: "#f0f2f5",
  surface: "#ffffff",
  text: "#1a1a1a",
  textSecondary: "#555566",
  accent: "#2563eb",
  border: "#dde1e8",
  selected: "#dbeafe",
  hover: "#e8ecf2",
};
